var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CampaignEditSegmentationList"}},[_c('Page',{attrs:{"title":((_vm.$t('Editing')) + " '" + (_vm.campaign.name) + "'"),"secondaryActions":[{
      label: _vm.$t('Notes'),
      onAction: function () { _vm.eventHub.$emit('showCampaignNotes', _vm.campaign.id) }
    }],"primaryAction":{
      label: _vm.$t('Add Segment'),
      onAction: function () { return _vm.createNewSegment(); },
      disabled: _vm.saving
    },"size":"fullWidth"}},[_c('campaign-edit-header',{attrs:{"campaign":_vm.campaign}}),(_vm.loading)?_c('LoadingLayout'):_vm._e(),(!_vm.loading)?_c('Layout',[_c('LayoutSection',[_c('Card',{attrs:{"title":_vm.$t('Segments')}},[_c('Filters',{attrs:{"filters":_vm.filters,"query":_vm.query,"applied-filters":_vm.appliedFilters},on:{"update:query":[function($event){_vm.query=$event},_vm.setQuery],"update:applied-filters":_vm.setAppliedFilters}}),_c('DataTable',{attrs:{"columns":[
              {
                key: 'name',
                label: _vm.$t('Name'),
                sortable: true, 
                fixed: true,
                minWidth: 250
              },
              {
                key: 'typeLabel',
                label: _vm.$t('Type'),
                sortable: true
              },
              {
                key: 'statusLabel',
                label: _vm.$t('Status'),
                sortable: true
              },
              {
                key: 'updatedOn',
                label: _vm.$t('Updated'),
                format: 'dateShort',
                sortable: true
              },
              {
                key: 'options',
                label: _vm.$t('Options'),
                sortable: false
              },
              {
                key: 'widget',
                label: _vm.$t('Widget'),
                sortable: true, 
                minWidth: 220,
                wrap: true
              },
              {
                key: 'numOffers',
                label: _vm.$t('# Offers'),
                sortable: true
              }
            ],"rows":_vm.formattedSegments,"row-actions":function (row) { return ([
              {
                label: _vm.$t('Copy'),
                onAction: function (segment) { return _vm.showCopyModal(segment); },
                disabled: _vm.saving
              },
              {
                label: row.status === 'active' ? _vm.$t('Disable') : _vm.$t('Enable'),
                onAction: function (segment) { return _vm.toggleSegment(segment); },
                disabled: _vm.saving
              },
              {
                label: _vm.$t('Delete'),
                onAction: function (segment) { return _vm.deleteSegment(segment); },
                disabled: _vm.saving
              }
            ]); },"sort":_vm.sortBy,"bulk-actions":_vm.bulkActions,"selected-ids":_vm.selectedIds,"pagination":{
              offset: _vm.offset,
              limit: _vm.limit,
              total: _vm.formattedSegments.length,
              updateOffset: function (val) { return _vm.offset = val; },
              updateLimit: _vm.updateLimit
            },"compact":""},on:{"update:sort":function($event){_vm.sortBy=$event},"update:selectedIds":function($event){_vm.selectedIds=$event},"update:selected-ids":function($event){_vm.selectedIds=$event}},scopedSlots:_vm._u([{key:"col:name",fn:function(ref){
            var row = ref.row;
return [_c('PageLink',{attrs:{"href":_vm.getSegmentUrl(row)}},[_vm._v(_vm._s(row.name))])]}},{key:"col:options",fn:function(ref){
            var row = ref.row;
return [(row.options.length)?_vm._l((row.options),function(opt,index){return _c('Badge',{key:index,attrs:{"size":"small"}},[_vm._v(_vm._s(opt.label))])}):[_vm._v("—")]]}},{key:"col:widget",fn:function(ref){
            var row = ref.row;
return [(row.type === 'include' || row.type === 'exit-intent')?[(row.widgetId === -1 && _vm.offerFlyoutWidgetName)?[_c('Badge',{attrs:{"size":"small"}},[_c('PageLink',{attrs:{"href":("/creative/index.html#!/revisions/" + _vm.offerFlyoutId),"external":""}},[_vm._v(_vm._s(_vm.$t('Campaign Offer Flyout')))])],1)]:(row.widget)?[_c('PageLink',{attrs:{"href":("/creative/index.html#!/revisions/" + (row.widgetId)),"external":""}},[_vm._v(_vm._s(row.widget))])]:[_vm._v("—")]]:[_vm._v("—")]]}},{key:"col:statusLabel",fn:function(ref){
            var row = ref.row;
return [_c('Badge',{attrs:{"status":row.status === 'disabled' ? 'warning' : 'success'}},[_vm._v(_vm._s(row.statusLabel))])]}},{key:"col:numOffers",fn:function(ref){
            var row = ref.row;
return [(row.numOffers)?[_c('PageLink',{on:{"click":function($event){return _vm.showOffers(row)}}},[_vm._v(_vm._s(row.numOffers))])]:[_vm._v("0")]]}}],null,false,1681356888)})],1)],1),_c('Modal',{attrs:{"title":_vm.$t('Copy Segment'),"primaryAction":{
          type: 'primary',
          label: _vm.$t('Copy segment'),
          onAction: function () { return _vm.copySegment(false); }
        },"secondaryActions":[
          {
            label: _vm.$t('Cancel'),
            onAction: function () { return _vm.copySegmentId = null; }
          },
          {
            label: _vm.$t('Copy segment & edit'),
            onAction: function () { return _vm.copySegment(true); }
          }
        ],"visible":!!_vm.copySegmentId},on:{"close":function($event){_vm.copySegmentId = null}}},[_c('p',[_vm._v(_vm._s(_vm.$t('campaignEdit.segment.copySegmentMsg')))]),_c('br'),_c('FormLayout',[_c('TextField',{attrs:{"label":_vm.$t('Segment Name')},model:{value:(_vm.copySegmentName),callback:function ($$v) {_vm.copySegmentName=$$v},expression:"copySegmentName"}}),_c('Select',{attrs:{"label":_vm.$t('Destination Campaign'),"options":_vm.campaignOptions,"searchable":true},model:{value:(_vm.copySegmentCampaignId),callback:function ($$v) {_vm.copySegmentCampaignId=$$v},expression:"copySegmentCampaignId"}})],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }